<template>
    <div class="float-left">
        <span
            @click.stop="abrirModalInserirSubItem()"
            class="icon-button"
            title="Subitens"
        >
            <i class="fa fa-info-circle fa-lg text-primary"></i>
            Subitens ({{
                subItensContrato != undefined ? subItensContrato.length : 0
            }})
        </span>
        <b-modal
            id="modalInserirSubItem"
            v-model="mostrarModalInserirSubItem"
            size="lg"
        >
            <div slot="modal-title">
                Sub Item -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Descrição</label>
                        <b-form-textarea
                            v-model="descricao"
                            :rows="4"
                            @input="$v.descricao.$touch()"
                            :state="$v.descricao.$error ? false : null"
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >A descrição é obrigatória</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Descrição Resumida</label>
                        <b-form-textarea
                            v-model="descricaoResumida"
                            :rows="4"
                            :maxlength="200"
                        ></b-form-textarea>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group
                        :state="$v.valor.$error ? false : null"
                        invalid-feedback="Valor é obrigatório"
                    >
                        <label>Valor</label>
                        <money
                            v-model="valor"
                            v-bind="money"
                            class="form-control text-right"
                            @input.native="$v.valor.$touch()"
                        ></money>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Quantidade</label>
                        <b-form-input
                            type="number"
                            v-model="quantidade"
                        ></b-form-input>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12" md="12">
                    <label for="tblSubItens">Sub Itens</label>
                    <app-tabela
                        idTabela="tblSubItens"
                        :itens="subItensContrato"
                        :campos="campos"
                        :itensPorPagina="itensPorPagina"
                    >
                        <template slot="acoes" slot-scope="data">
                            <div class="float-left">
                                <span class="text-primary mr-1">
                                    <i
                                        class="fa fa-edit fa-lg icon-button"
                                        title="Editar sub item contrato"
                                        @click.stop="
                                            editarSubItemContrato(data)
                                        "
                                    ></i>
                                </span>
                                <span class="text-danger">
                                    <i
                                        class="fa fa-trash fa-lg mr-2 icon-button"
                                        title="Excluir sub item contrato"
                                        @click.stop="
                                            confirmarRemocaoSubItemContrato(
                                                data
                                            )
                                        "
                                    ></i>
                                </span>
                            </div>
                        </template>
                        <template slot="valor" slot-scope="data">
                            <span class="text-nowrap">{{
                                data.valorUnitario | currency
                            }}</span>
                        </template>
                    </app-tabela>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharModalInserirSubItem()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="primary"
                    :disabled="desabilitarBtnSalvar"
                    @click.stop="processarSubItemContrato()"
                    class="ml-1"
                    >{{ textoBotao }}</b-button
                >
            </div>
        </b-modal>
    </div>
</template>

<script>
import { required, minValue } from 'vuelidate/lib/validators'
import PreContratoServicos from './PreContratoServicos'

export default {
    props: {
        parentData: Object,
        desativarBotao: Boolean,
        subItens: Array
    },

    data() {
        return {
            subItensContrato: this.subItens,
            itemContrato: this.parentData,
            subItem: {},
            descricao: '',
            descricaoResumida: '',
            valor: 0,
            quantidade: 0,
            mostrarModalInserirSubItem: false,
            operacao: 'INSERÇÃO',
            textoBotao: 'Inserir',
            erros: [],
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            campos: [
                {
                    key: 'descricao',
                    label: 'Descrição',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'descricaoResumida',
                    label: 'Descrição Resumida',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'valor',
                    label: 'Valor',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'quantidade',
                    label: 'Quantidade',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 5
        }
    },

    methods: {
        abrirModalInserirSubItem() {
            if (!this.desativarBotao) {
                this.subItensContrato = this.obterSubItens()
                this.mostrarModalInserirSubItem = true
            }
        },

        fecharModalInserirSubItem() {
            this.operacao = 'INSERÇÃO'
            this.textoBotao = 'Inserir'
            this.mostrarModalInserirSubItem = false
            this.resetInserirSubItem()
        },

        resetInserirSubItem() {
            this.operacao = 'INSERÇÃO'
            this.textoBotao = 'Inserir'
            this.descricao = ''
            this.descricaoResumida = ''
            this.valor = 0
            this.quantidade = 0
            this.erros = []
            this.subItem = {}
            this.$nextTick(() => {
                this.$v.$reset()
            })
        },

        processarSubItemContrato() {
            this.subItem.descricao = this.descricao
            this.subItem.descricaoResumida = this.descricaoResumida
            this.subItem.valorUnitario = this.valor
            this.subItem.quantidade = this.quantidade
            this.subItem.status = 1
            this.subItem.ordem = 1
            this.subItem.saldoValor = this.valor
            this.subItem.saldoQuantidade = this.quantidade
            this.subItem.seqRM = 0
            this.subItem.nuTipoAditivo = 0

            if (this.textoBotao == 'Atualizar') {
                PreContratoServicos.atualizarSubItemContrato(this.subItem).then(
                    response => {
                        if (response) {
                            if (response.success) {
                                this.subItensContrato = response.data
                                this.resetInserirSubItem()

                                this.$toast.success(
                                    'Subitem atualizado com sucesso!',
                                    'OK',
                                    this.$toastConfig.success
                                )
                            }
                        }
                    }
                )
            } else {
                this.subItem.idContrato = this.parentData.idContrato
                this.subItem.idItemReferencia = this.parentData.itemContratoId

                //this.$emit('salvarSubitem', this.subItem)

                PreContratoServicos.inserirSubItemContrato(this.subItem).then(
                    response => {
                        if (response) {
                            if (response.success) {
                                this.subItensContrato = response.data
                                this.resetInserirSubItem()

                                this.$toast.success(
                                    'Subitem adicionado com sucesso!',
                                    'OK',
                                    this.$toastConfig.success
                                )
                            }
                        }
                    }
                )
            }
            //this.fecharModalInserirSubItem()
        },

        obterSubItens() {
            this.$store.dispatch('addRequest')
            PreContratoServicos.obterSubItensContrato(
                this.parentData.idContrato,
                this.parentData.itemContratoId
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.subItensContrato = response.data

                        //this.$emit('qtdSubItens', this.subItensContrato.length)
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        editarSubItemContrato(subItem) {
            this.operacao = 'EDIÇÃO'
            this.textoBotao = 'Atualizar'
            this.descricao = subItem.descricao
            this.descricaoResumida = subItem.descricaoResumida
            this.valor = subItem.valorUnitario
            this.quantidade = subItem.quantidade
            this.subItem.itemContratoId = subItem.itemContratoId
            this.subItem.idContrato = subItem.idContrato
            this.subItem.idItemReferencia = subItem.idItemReferencia
        },

        confirmarRemocaoSubItemContrato(subItem) {
            this.$swal({
                title: 'Excluir sub item contrato',
                html: `Confirma a exclusão do sub item do contrato?
                <br/><br/><div class="alert alert-danger" role="alert">
                        Atenção! Essa é uma operação irreversível!
                    </div>`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then(result => {
                if (result.value) {
                    this.excluirSubItemContrato(subItem)
                }
            })
        },

        excluirSubItemContrato(subItem) {
            PreContratoServicos.removerSubItemContrato(
                subItem.idContrato,
                subItem.itemContratoId,
                subItem.idItemReferencia
            ).then(response => {
                if (response) {
                    if (response.success) {
                        this.subItensContrato = response.data
                    }
                }
            })
        }
    },

    created() {
        this.obterSubItens()
    },

    computed: {
        desabilitarBtnSalvar() {
            return this.$v.$invalid
        }
    },

    watch: {},

    validations: {
        descricao: {
            required
        },
        valor: {
            required,
            minValue: minValue(0.01)
        }
    }
}
</script>
